import Store from '../store';
import { FirebaseService } from '@/services/firebase';
import { LoggingService } from '@/services/logging';

export const LocationSyncer = {
  async trySubmitUnsynced() {
    const unsyncedLocations = Store.getters.unsyncedLocations;

    if (!unsyncedLocations || unsyncedLocations.length === 0) {
      return;
    }

    LoggingService.Log(`attempting to sync ${unsyncedLocations.length} locations`);
    try {
      const success = await FirebaseService.saveVolunteerLocations(unsyncedLocations);
      LoggingService.Log(`sync attempt result: ${success}`);
      Store.commit('setLastSyncAttempt', {
        success: success !== false,
        timestamp: Date.now(),
      });
    } catch (error) {
      LoggingService.Log(`sync attempt error: ${error}`);
      Store.commit('setLastSyncAttempt', {
        success: false,
        timestamp: Date.now(),
        error: error instanceof Error ? error.message : String(error),
      });
    }
  },
};
